import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import CBMediaQuery from '../../shared/CBMediaQuery';
import { getStyle, formatDate } from '../../../utils/utils';
import CBInputField from '../../shared/form_components/CBInputField';
import CBSelectField from '../../shared/form_components/CBSelectField';
import CBSpinnerFloating from '../../shared/CBSpinnerFloating';
import CBPromptModal from '../../shared/CBPromptModal';
import { Button } from 'primereact/button';
import { MultiSelect } from 'primereact/multiselect';
import {
  createChainPermission as _createChainPermission,
  updateChainPermission as _updateChainPermission,
  deleteChainPermission as _deleteChainPermission,
} from '../../../actions/chainActions';
import { getEmailValidator, getLengthValidator } from '../../../utils/validators';
import { T, cardStyle, inputStyle, inputLabelStyle, tagStyle } from './chainSettingsV2Styles';

class SettingsChainPermissionsV2 extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showAddForm: false,
      formData: {
        email: '',
        role: 'employee',
        messaging_roles: [],
      },
      formValid: {
        email: false,
      },
      deleteModalOpen: false,
      deleteTargetId: null,
    };
  }

  setIsValid = (name, isValid) => {
    var formValid = this.state.formValid;
    this.setState({
      formValid: { ...formValid, [name]: isValid },
    });
  };

  updateFormState = (changedObject) => {
    var formData = this.state.formData;
    this.setState({
      formData: { ...formData, [changedObject.target]: changedObject.value },
    });
  };

  submitForm = () => {
    var formData = this.state.formData;
    var createChainPermission = this.props.createChainPermission;
    var chainId = this.props.chainId;

    createChainPermission({
      chain: chainId,
      user_email: formData.email,
      role: formData.role,
      messaging_roles: formData.messaging_roles || [],
    });

    this.setState({
      showAddForm: false,
      formData: { email: '', role: 'employee', messaging_roles: [] },
      formValid: { email: false },
    });
  };

  openDeleteModal = (permissionId) => {
    this.setState({ deleteModalOpen: true, deleteTargetId: permissionId });
  };

  closeDeleteModal = () => {
    this.setState({ deleteModalOpen: false, deleteTargetId: null });
  };

  confirmDelete = () => {
    var deleteChainPermission = this.props.deleteChainPermission;
    var deleteTargetId = this.state.deleteTargetId;
    if (deleteTargetId) {
      deleteChainPermission(deleteTargetId);
    }
    this.closeDeleteModal();
  };

  handleRoleChange = (permissionId, newRole) => {
    var updateChainPermission = this.props.updateChainPermission;
    updateChainPermission(permissionId, { role: newRole });
  };

  handleMessagingRolesChange = (permissionId, newRoles) => {
    var updateChainPermission = this.props.updateChainPermission;
    updateChainPermission(permissionId, { messaging_roles: newRoles });
  };

  getRoleTagVariant = (role) => {
    switch (role) {
      case 'admin': return 'active';
      case 'manager': return 'active';
      default: return 'default';
    }
  };

  getRoleLabel = (role) => {
    var t = this.props.t;
    switch (role) {
      case 'admin': return t('roleAdmin');
      case 'manager': return t('roleManager');
      case 'employee': return t('roleEmployee');
      default: return role;
    }
  };

  getInitials = (permission) => {
    var firstName = permission.user && permission.user.profile && permission.user.profile.first_name;
    var lastName = permission.user && permission.user.profile && permission.user.profile.last_name;
    var first = firstName ? firstName.charAt(0) : '';
    var last = lastName ? lastName.charAt(0) : '';
    return (first + last).toUpperCase() || '?';
  };

  isPending = (permission) => {
    return !permission.user && permission.invitation;
  };

  getUserDisplayName = (permission) => {
    if (permission.user && permission.user.profile) {
      var name = (permission.user.profile.first_name || '') + ' ' + (permission.user.profile.last_name || '');
      return name.trim() || '-';
    }
    if (permission.invitation) {
      return permission.invitation.email;
    }
    return '-';
  };

  getUserDisplayEmail = (permission) => {
    if (permission.user) {
      return permission.user.email || '-';
    }
    return '';
  };

  render() {
    var t = this.props.t;
    var chainPermissions = this.props.chainPermissions;
    var permissionsStatus = this.props.permissionsStatus;
    var showAddForm = this.state.showAddForm;
    var formData = this.state.formData;
    var formValid = this.state.formValid;
    var deleteModalOpen = this.state.deleteModalOpen;

    var isLoading = permissionsStatus && permissionsStatus.loading;

    var roleOptions = [
      { value: 'admin', label: t('roleAdmin') },
      { value: 'manager', label: t('roleManager') },
      { value: 'employee', label: t('roleEmployee') },
    ];

    return (
      <CBMediaQuery>
        {screenSize => (
          <div style={getStyle(screenSize, styles, 'card')}>
            <div style={getStyle(screenSize, styles, 'header')}>
              <div style={getStyle(screenSize, styles, 'headerLeft')}>
                <div style={getStyle(screenSize, styles, 'iconBox')}>
                  <i className="pi pi-users" style={{ fontSize: 20, color: T.accent }} />
                </div>
                <div>
                  <h2 style={getStyle(screenSize, styles, 'title')}>{t('chainPermissionsTitle')}</h2>
                  <p style={getStyle(screenSize, styles, 'description')}>{t('permissionsDescription')}</p>
                </div>
              </div>
              {!showAddForm && (
                <Button
                  onClick={() => this.setState({ showAddForm: true })}
                  label={t('addPermission')}
                  style={{
                    backgroundColor: T.accent,
                    border: 'none',
                    color: '#0077b0',
                    fontWeight: 600,
                    fontSize: 13,
                  }}
                />
              )}
            </div>

            {showAddForm && (
              <div style={getStyle(screenSize, styles, 'addForm')}>
                <div style={getStyle(screenSize, styles, 'addFormFields')}>
                  <div style={{ flex: 1, minWidth: 200 }}>
                    <CBInputField
                      name="email"
                      inputStyle={inputStyle}
                      value={formData.email}
                      placeholder=""
                      type="email"
                      onChange={this.updateFormState}
                      validators={[getLengthValidator(1, 100), getEmailValidator()]}
                      isValidCallback={this.setIsValid}
                      labelText={t('emailLabel')}
                      labelTextStyle={inputLabelStyle}
                    />
                  </div>
                  <div style={{ width: 180 }}>
                    <CBSelectField
                      name="role"
                      value={formData.role}
                      options={roleOptions}
                      onChange={this.updateFormState}
                      labelText={t('roleLabel')}
                      labelTextStyle={inputLabelStyle}
                      inputStyle={{ ...getStyle(screenSize, styles, 'roleSelect'), height: 42, fontSize: 14 }}
                      optionStyle={{ color: '#000' }}
                      containerStyle={{ margin: 0 }}
                    />
                  </div>
                  {/* Messaging roles hidden for now
                  <div style={{ width: 200 }}>
                    <span style={inputLabelStyle}>{t('messagingRoles')}</span>
                    <MultiSelect
                      value={formData.messaging_roles || []}
                      options={[{ label: t('chainContact'), value: 'chain_contact' }]}
                      onChange={(e) => this.setState({ formData: { ...formData, messaging_roles: e.value } })}
                      placeholder={t('selectMessagingRoles')}
                      style={{ width: '100%', marginTop: 4 }}
                    />
                  </div>
                  */}
                </div>
                <div style={getStyle(screenSize, styles, 'addFormButtons')}>
                  <Button
                    onClick={this.submitForm}
                    label={t('save')}
                    disabled={!formValid.email || isLoading}
                    style={{
                      backgroundColor: '#fff',
                      border: 'none',
                      color: '#0077b0',
                      fontWeight: 600,
                    }}
                  />
                  <Button
                    onClick={() => this.setState({ showAddForm: false })}
                    label={t('cancel')}
                    severity="secondary"
                    outlined
                    style={{
                      borderColor: T.inBdr,
                      color: T.textSecondary,
                    }}
                  />
                </div>
              </div>
            )}

            {isLoading && (
              <div style={{ position: 'relative', minHeight: 60 }}>
                <CBSpinnerFloating color={T.accent} />
              </div>
            )}

            {!isLoading && (
              <div style={getStyle(screenSize, styles, 'table')}>
                {chainPermissions.length === 0 && (
                  <p style={{ color: T.textMuted, fontSize: 14, textAlign: 'center', padding: 32 }}>
                    {t('noPermissions')}
                  </p>
                )}

                {screenSize === 'large' && chainPermissions.length > 0 && (
                  <div style={getStyle(screenSize, styles, 'tableHeader')}>
                    <span style={{ ...styles.default.colUser, color: T.textMuted, fontSize: 11, fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5 }}>{t('userColumn')}</span>
                    <span style={{ ...styles.default.colRole, color: T.textMuted, fontSize: 11, fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5 }}>{t('roleColumn')}</span>
                    {/* <span style={{ ...styles.default.colMessagingRoles, color: T.textMuted, fontSize: 11, fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5 }}>{t('messagingRolesColumn')}</span> */}
                    <span style={{ ...styles.default.colDate, color: T.textMuted, fontSize: 11, fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5 }}>{t('addedColumn')}</span>
                    <span style={styles.default.colActions} />
                  </div>
                )}

                {screenSize === 'large' && chainPermissions.map(permission => {
                  var pending = this.isPending(permission);

                  return (
                    <div key={permission.id} style={getStyle(screenSize, styles, 'row')}>
                      <div style={styles.default.colUser}>
                        <div style={getStyle(screenSize, styles, 'userCell')}>
                          {pending ? (
                            <div style={{
                              ...getStyle(screenSize, styles, 'avatar'),
                              backgroundColor: 'rgba(255, 255, 255, 0.1)',
                            }}>
                              <i className="pi pi-envelope" style={{ fontSize: 14, color: 'rgba(255, 255, 255, 0.6)' }} />
                            </div>
                          ) : (
                            <div style={getStyle(screenSize, styles, 'avatar')}>
                              {this.getInitials(permission)}
                            </div>
                          )}
                          <div>
                            <div style={{ color: T.textPrimary, fontSize: 14, fontWeight: 500, display: 'flex', alignItems: 'center', gap: 8 }}>
                              {this.getUserDisplayName(permission)}
                              {pending && (
                                <span style={tagStyle('pending')}>{t('pending')}</span>
                              )}
                            </div>
                            {this.getUserDisplayEmail(permission) && (
                              <div style={{ color: T.textMuted, fontSize: 12 }}>
                                {this.getUserDisplayEmail(permission)}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div style={styles.default.colRole}>
                        <CBSelectField
                          name={'role_' + permission.id}
                          value={permission.role}
                          options={roleOptions}
                          onChange={(change) => this.handleRoleChange(permission.id, change.value)}
                          inputStyle={getStyle(screenSize, styles, 'roleSelect')}
                          optionStyle={{ color: '#000' }}
                          containerStyle={{ margin: 0 }}
                        />
                      </div>
                      {/* Messaging roles hidden for now
                      <div style={styles.default.colMessagingRoles}>
                        <MultiSelect
                          value={permission.messaging_roles || []}
                          options={[{ label: t('chainContact'), value: 'chain_contact' }]}
                          onChange={(e) => this.handleMessagingRolesChange(permission.id, e.value)}
                          placeholder={t('selectMessagingRoles')}
                          style={{ width: '100%', fontSize: 13, height: 32 }}
                        />
                      </div>
                      */}
                      <div style={styles.default.colDate}>
                        <span style={{ color: T.textSecondary, fontSize: 13 }}>
                          {permission.created_at ? formatDate(permission.created_at) : '-'}
                        </span>
                      </div>
                      <div style={styles.default.colActions}>
                        <Button
                          onClick={() => this.openDeleteModal(permission.id)}
                          icon="pi pi-trash"
                          text
                          rounded
                          style={{ color: 'rgba(255, 255, 255, 0.4)', width: 36, height: 36 }}
                        />
                      </div>
                    </div>
                  );
                })}

                {screenSize !== 'large' && chainPermissions.map(permission => {
                  var pending = this.isPending(permission);

                  return (
                    <div key={permission.id} style={getStyle(screenSize, styles, 'mobileCard')}>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                          {pending ? (
                            <div style={{
                              ...getStyle(screenSize, styles, 'avatar'),
                              backgroundColor: 'rgba(255, 255, 255, 0.1)',
                            }}>
                              <i className="pi pi-envelope" style={{ fontSize: 14, color: 'rgba(255, 255, 255, 0.6)' }} />
                            </div>
                          ) : (
                            <div style={getStyle(screenSize, styles, 'avatar')}>
                              {this.getInitials(permission)}
                            </div>
                          )}
                          <div>
                            <div style={{ color: T.textPrimary, fontSize: 14, fontWeight: 500, display: 'flex', alignItems: 'center', gap: 8 }}>
                              {this.getUserDisplayName(permission)}
                              {pending && (
                                <span style={tagStyle('pending')}>{t('pending')}</span>
                              )}
                            </div>
                            {this.getUserDisplayEmail(permission) && (
                              <div style={{ color: T.textMuted, fontSize: 12 }}>
                                {this.getUserDisplayEmail(permission)}
                              </div>
                            )}
                          </div>
                        </div>
                        <Button
                          onClick={() => this.openDeleteModal(permission.id)}
                          icon="pi pi-trash"
                          text
                          rounded
                          style={{ color: 'rgba(255, 255, 255, 0.4)', width: 36, height: 36 }}
                        />
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12 }}>
                        <CBSelectField
                          name={'role_' + permission.id}
                          value={permission.role}
                          options={roleOptions}
                          onChange={(change) => this.handleRoleChange(permission.id, change.value)}
                          inputStyle={getStyle(screenSize, styles, 'roleSelect')}
                          optionStyle={{ color: '#000' }}
                          containerStyle={{ margin: 0, flex: 1 }}
                        />
                        <span style={{ color: T.textSecondary, fontSize: 12 }}>
                          {permission.created_at ? formatDate(permission.created_at) : '-'}
                        </span>
                      </div>
                      {/* Messaging roles hidden for now
                      <div style={{ marginTop: 8 }}>
                        <MultiSelect
                          value={permission.messaging_roles || []}
                          options={[{ label: t('chainContact'), value: 'chain_contact' }]}
                          onChange={(e) => this.handleMessagingRolesChange(permission.id, e.value)}
                          placeholder={t('selectMessagingRoles')}
                          style={{ width: '100%', fontSize: 13 }}
                        />
                      </div>
                      */}
                    </div>
                  );
                })}
              </div>
            )}

            <CBPromptModal
              modalIsOpen={deleteModalOpen}
              closeModal={this.closeDeleteModal}
              performAction={this.confirmDelete}
              title={t('deletePermissionTitle')}
              text={t('deletePermissionText')}
              buttonText={t('deletePermissionButton')}
            />
          </div>
        )}
      </CBMediaQuery>
    );
  }
}

var styles = {
  default: {
    card: {
      ...cardStyle,
      position: 'relative',
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      marginBottom: 24,
      flexWrap: 'wrap',
      gap: 12,
    },
    headerLeft: {
      display: 'flex',
      alignItems: 'center',
      gap: 16,
    },
    iconBox: {
      width: 48,
      height: 48,
      borderRadius: 12,
      backgroundColor: 'rgba(255, 255, 255, 0.15)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
    },
    title: {
      color: T.textPrimary,
      fontSize: 18,
      fontWeight: 600,
      margin: 0,
    },
    description: {
      color: T.textSecondary,
      fontSize: 13,
      margin: '4px 0 0 0',
    },
    addForm: {
      backgroundColor: 'rgba(255, 255, 255, 0.06)',
      padding: 20,
      borderRadius: 10,
      marginBottom: 24,
      border: '1px solid ' + T.border,
    },
    addFormFields: {
      display: 'flex',
      gap: 16,
      flexWrap: 'wrap',
    },
    addFormButtons: {
      display: 'flex',
      gap: 12,
      marginTop: 16,
    },
    table: {},
    tableHeader: {
      display: 'flex',
      alignItems: 'center',
      padding: '8px 16px',
      borderBottom: '1px solid ' + T.border,
      marginBottom: 4,
    },
    row: {
      display: 'flex',
      alignItems: 'center',
      padding: '12px 16px',
      borderRadius: 8,
      transition: 'background 0.15s ease',
      borderBottom: '1px solid ' + T.borderLight,
    },
    colUser: {
      flex: 3,
      minWidth: 0,
    },
    colRole: {
      flex: 1.5,
      minWidth: 120,
    },
    colMessagingRoles: {
      flex: 1.5,
      minWidth: 150,
    },
    roleSelect: {
      backgroundColor: 'rgba(255, 255, 255, 0.1)',
      fontSize: 13,
      color: '#fff',
      borderRadius: 6,
      height: 32,
      border: '1px solid ' + T.border,
      paddingLeft: 8,
      paddingRight: 8,
    },
    colDate: {
      flex: 1.5,
      minWidth: 80,
    },
    colActions: {
      width: 48,
      display: 'flex',
      justifyContent: 'flex-end',
    },
    userCell: {
      display: 'flex',
      alignItems: 'center',
      gap: 12,
    },
    avatar: {
      width: 38,
      height: 38,
      borderRadius: '50%',
      backgroundColor: 'rgba(255, 255, 255, 0.12)',
      color: T.accent,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: 13,
      fontWeight: 700,
      flexShrink: 0,
    },
  },
  medium: {
    card: {
      ...cardStyle,
      padding: 16,
    },
    mobileCard: {
      backgroundColor: 'rgba(255, 255, 255, 0.06)',
      borderRadius: 10,
      padding: 14,
      marginBottom: 8,
      border: '1px solid ' + T.borderLight,
    },
    addFormFields: {
      flexDirection: 'column',
    },
  },
};

function mapStateToProps(state) {
  return {
    chainPermissions: state.chain.chainPermissions,
    permissionsStatus: state.chain.chainPermissionsStatus,
  };
}

export default connect(
  mapStateToProps,
  {
    createChainPermission: _createChainPermission,
    updateChainPermission: _updateChainPermission,
    deleteChainPermission: _deleteChainPermission,
  },
)(translate('ChainSettingsView')(SettingsChainPermissionsV2));
